<template>
  <v-container id="certificateView" tag="section" class="fill-height justify-center">
    <div v-if="!busy" width="100%">
      <certificate-badge :id="certificate.sn" :model="certificate" />
      <a href="#" @click="downloadmodel(certificate.sn)">{{ $t('certficateDisplay.download-certificate') }}</a>
    </div>
    <div v-if="busy">
      <v-overlay :value="busy">
        <v-progress-circular
          indeterminate
          size="56"
        />
      </v-overlay>
    </div>
  </v-container>
</template>

<script>
  import api from '@/helpers/api.js'
  import certificateBadge from '../components/CertificateBadge.vue'
  import html2canvas from 'html2canvas'
  // import { ContentLibrary } from '@/helpers/contentLibrary.js'

  export default {
    name: 'Certificate',
    
    components: {
      'certificate-badge': certificateBadge,
    },

    data () { 
      return {
        busy: true,
        show: false, 
        certificate: undefined,
      }
    },
    
    async mounted () {
      this.busy = true
      try {
        if (this.$route.query.lang) {
          this.$i18n.locale = this.$route.query.lang
        }
        const response = await api.getCertificate(this.$route.params.id)
        
        const content = await api.getContent(response.module)

        response.title = content.locales[this.$i18n.locale]?.title ?? content.locales.en?.title ?? content.title
        this.certificate = response
      } catch (ex) {
        // check if ex is a 404
        if (ex.response.status === 404) {
          this.$router.push({ name: 'notFound' })
        }
      }

      this.busy = false
    },

    methods: { 
      downloadmodel (id) {
        html2canvas(document.getElementById(id), { backgroundColor: null }).then(canvas => {
          const image = canvas.toDataURL()
          const a = document.createElement('a')
          document.body.appendChild(a)
          a.href = image
          a.download = 'Bodyswaps_Certificate_' + id + '.png'
          a.click()
          document.body.removeChild(a)
        })
      },
    },
  }

</script>

<style scoped>

#badge {
  margin-left: auto;
  margin-right: auto;
  width: 600px;
}

</style>
